// 옛 주소 /Admin/AdminSetting 은 관리자 '내 계정 > 설정'으로 리다이렉트되어 이 화면은 더 이상 그려지지 않는다.
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { LanguageCode } from '../../config';
import { AuthAction } from '../../actions';
import { RayForm } from '../../components/common';
import { Translate as t } from '../../config/Translate';

const AdminSetting = ({ updateUserSetting, user }) => {

	const [settings, setSettings] = useState({});

	useEffect(() => {
		setSettings(user.settings);
	}, [user.settings]);

	const fc_dashboard = [
		{
			title: t('dashboard.title'), items: [
				{ type: "number", name: "aggrserviceoverdueonlycount", label: t('dashboard.setting.overdueDays'), val: settings.aggrserviceoverdueonlycount || 7 },
				{ type: "number", name: "aggrerrorlastndays", label: t('dashboard.setting.errorsLastNDays'), val: settings.aggrerrorlastndays || 1 },
				{ type: "number", name: "aggrerrornotcloselastndays", label: t('dashboard.setting.errorsOverdueDays'), val: settings.aggrerrornotcloselastndays || 1 },
				{
					type: "select2", name: "dashboardmodelchart", label: t('dashboard.setting.modelChart'), val: settings.dashboardmodelchart || "pie", list: [
						{ code: "pie", title: t('dashboard.setting.pieChart') },
						{ code: "bar", title: t('dashboard.setting.horizontalBarChart') },
						{ code: "hide", title: t('dashboard.setting.hide') },
					]
				},
				{ type: "number", name: "dashboardmodelchartlimit", label: t('dashboard.setting.modelChartLimit'), val: settings.dashboardmodelchartlimit || 5 },

				{ type: "number", name: "dashboardaggrerrorpercentlastndays", label: t('dashboard.setting.errorChartLastNDays'), val: settings.dashboardaggrerrorpercentlastndays || 7 },
				{ type: "number", name: "dashboardaggrerrorpercentlimit", label: t('dashboard.setting.errorChartLastNDaysLimit'), val: settings.dashboardaggrerrorpercentlimit || 5 },
				{
					type: "select2", name: "dashboardaggrerrorpercent", label: t('dashboard.setting.errorChartLastNDaysOption'), val: settings.dashboardaggrerrorpercent || "pie", list: [
						{ code: "pie", title: t('dashboard.setting.pieChart') },
						{ code: "bar", title: t('dashboard.setting.horizontalBarChart') },
						{ code: "hide", title: t('dashboard.setting.hide') },
					]
				},

				{
					type: "select2", name: "dashboardaggrerrorchartlastndaysshow", label: t('dashboard.setting.acquisitionsDailyChartShow'), val: settings.dashboardaggrerrorchartlastndaysshow || "Y", list: [
						{ code: "Y", title: t('dashboard.setting.show') },
						{ code: "N", title: t('dashboard.setting.hide') },
					]
				},
				{
					type: "select2", name: "dashboardaggrerrorchartlastndays", label: t('dashboard.setting.errorDailyChartNDays'), val: settings.dashboardaggrerrorchartlastndays || 14, list: [
						{ code: 7, title: t('common.label.oneWeek') },
						{ code: 14, title: t('common.label.twoWeeks') },
						{ code: 21, title: t('common.label.threeWeeks') },
						{ code: 28, title: t('common.label.fourWeeks') },
					]
				},
				{
					type: "select2", name: "dashboardaggracqchartlastndaysshow", label: t('dashboard.setting.acquisitionsDailyChartShow'), val: settings.dashboardaggracqchartlastndaysshow || "Y", list: [
						{ code: "Y", title: t('dashboard.setting.show') },
						{ code: "N", title: t('dashboard.setting.hide') },
					]
				},
				{
					type: "select2", name: "dashboardaggracqchartlastndays", label: t('dashboard.setting.acquisitionsDailyChartNDays'), val: settings.dashboardaggracqchartlastndays || 14, list: [
						{ code: 7, title: t('common.label.oneWeek') },
						{ code: 14, title: t('common.label.twoWeeks') },
						{ code: 21, title: t('common.label.threeWeeks') },
						{ code: 28, title: t('common.label.fourWeeks') },
					]
				},

				{ type: "number", name: "dashboardaggrservicelongclose", label: t('dashboard.setting.openLastNDays'), val: settings.dashboardaggrservicelongclose || 7 },
				//{ type : "number", name : "dashboardaggrservicelongcloselimit", label : "Open Service - Last 'N' Days - Limit", val : settings.dashboardaggrservicelongcloselimit || 7 },
				{ type: "number", name: "dashboarddashboardaggrserviceclosed", label: t('dashboard.setting.closedLastNDays'), val: settings.dashboarddashboardaggrserviceclosed || 7 },
			]
		},
	]
	const fc_product = [
		{
			title: t('product.title'), items: [
				{ type: "number", name: "dslatestinstalleddays", label: t('dashboard.setting.latestInstalledDays'), val: settings.dslatestinstalleddays || 5 },
				{ type: "number", name: "dslatestinstalledcount", label: t('dashboard.setting.latestInstalledCount'), val: settings.dslatestinstalledcount || 5 },
				{ type: "number", name: "dbprdlonguseyear", label: t('setting.label.oldProductYears'), val: settings.dbprdlonguseyear || 7 },
				{ type: "number", name: "dbprdlonguseyearshowcount", label: t('setting.label.oldProductCount'), val: settings.dbprdlonguseyearshowcount || 10 },
				{ type: "number", name: "dsprdcountlistcount", label: t('dashboard.setting.countryListCount'), val: settings.dsprdcountlistcount || 10 },
				{ type: "number", name: "dsprdoccerrorount", label: t('dashboard.setting.occurredErrorsCount'), val: settings.dsprdoccerrorount || 5 },
				{ type: "number", name: "dsprdsrvcount", label: t('dashboard.setting.serviceCount'), val: settings.dsprdsrvcount || 7 },
				{ type: "number", name: "dsprdacqcount", label: t('dashboard.setting.acquisitionsCount'), val: settings.dsprdacqcount || 7 },
			]
		},
	]
	const fc_service = [
		{
			title: t('service.title'), items: [
				{ type: "number", name: "dsservicecardduration", label: t('dashboard.setting.cardDurationDays'), val: settings.dsservicecardduration || 30 },
				{ type: "number", name: "dsservicecountrytop", label: t('dashboard.setting.countryTopN'), val: settings.dsservicecountrytop || 5 },
				{ type: "number", name: "dsserviceerrortop", label: t('dashboard.setting.errorTopN'), val: settings.dsserviceerrortop || 5 },
				{ type: "number", name: "dsservicestatustop", label: t('dashboard.setting.statusTopN'), val: settings.dsservicestatustop || 5 },
				{ type: "number", name: "dsservicemodeltop", label: t('dashboard.setting.modelTopN'), val: settings.dsservicemodeltop || 5 },
				{ type: "number", name: "dsservicenowclosedtop", label: t('dashboard.setting.openTopN'), val: settings.dsservicenowclosedtop || 10 },
				{
					type: "select2", name: "dsserviceservicestatusmonthchart", label: t('dashboard.setting.monthlyStatusNMonth'), val: settings.dsserviceservicestatusmonthchart || 12, list: [
						{ code: 12, title: t('common.label.twelveMonths') },
						{ code: 24, title: t('common.label.twentyFourMonths') },
						{ code: 36, title: t('common.label.thirtySixMonths') },
					]
				},
				{
					type: "select2", name: "dsserviceserviceallchart", label: t('dashboard.setting.incomingChartNDays'), val: settings.dsserviceserviceallchart || 180, list: [
						{ code: 30, title: t('common.label.oneMonth') },
						{ code: 60, title: t('common.label.twoMonths') },
						{ code: 90, title: t('common.label.threeMonths') },
						{ code: 180, title: t('common.label.sixMonths') },
					]
				},
				{
					type: "select2", name: "dsserviceservicestatuschart", label: t('dashboard.setting.statusChartNDays'), val: settings.dsserviceservicestatuschart || 14, list: [
						{ code: 7, title: t('common.label.oneWeek') },
						{ code: 14, title: t('common.label.twoWeeks') },
						{ code: 21, title: t('common.label.threeWeeks') },
					]
				},
				{
					type: "select2", name: "dsserviceerrorchart", label: t('dashboard.setting.errorChartNDays'), val: settings.dsserviceerrorchart || 14, list: [
						{ code: 7, title: t('common.label.oneWeek') },
						{ code: 14, title: t('common.label.twoWeeks') },
						{ code: 21, title: t('common.label.threeWeeks') },
					]
				},
				{
					type: "select2", name: "dsservicereplacementsdays", label: t('dashboard.setting.replacementsNDays'), val: settings.dsservicereplacementsdays || 14, list: [
						{ code: 7, title: t('common.label.oneWeek') },
						{ code: 14, title: t('common.label.twoWeeks') },
						{ code: 21, title: t('common.label.threeWeeks') },
						{ code: 28, title: t('common.label.fourWeeks') },
					]
				},
			]
		},
	]
	const fc_common = [
		{
			title: t('dashboard.setting.common'), items: [
				{
					type: "select2", name: "dashboardtablelistcount", label: t('dashboard.setting.tableListCount'), val: settings.dashboardtablelistcount || 30, list: [
						{ code: 10, title: "10" },
						{ code: 20, title: "20" },
						{ code: 30, title: "30" },
						{ code: 40, title: "40" },
						{ code: 50, title: "50" },
						{ code: 100, title: "100" },
						{ code: 1000, title: "1000" },
					]
				},
				{
					type: "select2", name: "dashboardshowprogval", label: t('dashboard.setting.showValueInProgressBar'), val: settings.dashboardshowprogval || "N", list: [
						{ code: "Y", title: t('dashboard.setting.show') },
						{ code: "N", title: t('dashboard.setting.hide') },
					]
				},

			]
		},
	]

	const handleChangeData = (e) => {
		const { name, value } = e.target;
		// IMP-236: action creator 가 `settings.<name>` payload 책임을 가져감.
		// 호출 사이트는 name/value 의도만 전달. BE 계약 변경 시
		// AuthAction.updateUserSetting 한 곳만 수정.
		updateUserSetting(name, value);
	};

	return (
		<>
			<div className="extraHeader">
				<h2 className="mb-0">{t('common.label.settings')}</h2>
			</div>
			<div id="appCapsule" className="extra-header-active full-height">
				<div className="row">
					<div className="col">
						<RayForm
							controls={fc_dashboard}
							isForm={true}
							handleUpdateData={handleChangeData} />
					</div>
					<div className="col">
						<RayForm
							controls={fc_common}
							isForm={true}
							handleUpdateData={handleChangeData} />
						<RayForm
							controls={fc_product}
							isForm={true}
							handleUpdateData={handleChangeData} />
						<RayForm
							controls={fc_service}
							isForm={true}
							handleUpdateData={handleChangeData} />
					</div>
				</div>
			</div>
		</>
	);
};

const mapState = (state) => {
	const user = state.AuthReducer.user;
	return { user };
}

const mapDispatch = dispatch => ({
	// IMP-236: dotted payload 추상화. 호출 사이트는 name/value 의도만 전달.
	updateUserSetting: (name, value) => dispatch(AuthAction.updateUserSetting(name, value)),
})

export default connect(mapState, mapDispatch)(AdminSetting);
